import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Pessoas from '@/pages/Pessoas';
import Financeiros from '@/pages/Financeiros';
import FinanceirosAgrupados from '@/pages/FinanceirosAgrupados';
import EntradasSaidas from '@/pages/EntradasSaidas';
import Bancos from '@/pages/Bancos';
import Configuracoes from '@/pages/Configuracoes';
import Relatorios from '@/pages/Relatorios';
import Usuarios from '@/pages/Usuarios';
import Auditoria from '@/pages/Auditoria';
import AcertoMotoristas from '@/pages/AcertoMotoristas';
import Layout from '@/components/Layout';
import InstallPWA from '@/components/InstallPWA';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => {
          setUser(res.data.user);
        })
        .catch(() => {
          localStorage.removeItem('token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" /> : <Login setUser={setUser} />} />
          <Route path="/" element={user ? <Layout user={user} setUser={setUser}><Dashboard /></Layout> : <Navigate to="/login" />} />
          <Route path="/pessoas" element={user ? <Layout user={user} setUser={setUser}><Pessoas /></Layout> : <Navigate to="/login" />} />
          <Route path="/bancos" element={user ? <Layout user={user} setUser={setUser}><Bancos /></Layout> : <Navigate to="/login" />} />
          <Route path="/entradas-saidas" element={user ? <Layout user={user} setUser={setUser}><EntradasSaidas /></Layout> : <Navigate to="/login" />} />
          <Route path="/pagar" element={user ? <Layout user={user} setUser={setUser}><FinanceirosAgrupados tipo="pagar" /></Layout> : <Navigate to="/login" />} />
          <Route path="/receber" element={user ? <Layout user={user} setUser={setUser}><FinanceirosAgrupados tipo="receber" /></Layout> : <Navigate to="/login" />} />
          <Route path="/relatorios" element={user ? <Layout user={user} setUser={setUser}><Relatorios /></Layout> : <Navigate to="/login" />} />
          <Route path="/configuracoes" element={user?.role === 'admin' ? <Layout user={user} setUser={setUser}><Configuracoes /></Layout> : <Navigate to="/" />} />
          <Route path="/usuarios" element={user?.role === 'admin' ? <Layout user={user} setUser={setUser}><Usuarios /></Layout> : <Navigate to="/" />} />
          <Route path="/auditoria" element={user?.role === 'admin' ? <Layout user={user} setUser={setUser}><Auditoria /></Layout> : <Navigate to="/" />} />
          <Route path="/acerto-motoristas" element={user ? <Layout user={user} setUser={setUser}><AcertoMotoristas /></Layout> : <Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
      <InstallPWA />
    </>
  );
}

export default App;